import React, { ReactNode } from "react";
import Collapsible, {
    COLLAPSIBLE_COLOR_VARIANT,
    COLLAPSIBLE_TRIGGER_ICON_VARIANT, ICollapsibleProps,
} from "../../../../collapsible/collapsible";

type AppSidebarCollapsibleProps = {children: ReactNode} & Pick<ICollapsibleProps, 'title' | 'isExpanded'|'onToggle'>;

export const AppSidebarCollapsible: React.FC<AppSidebarCollapsibleProps> = ({ children, title, isExpanded, onToggle }) => {
    return (
        <Collapsible
            title={title}
            colorVariant={COLLAPSIBLE_COLOR_VARIANT.PRIMARY2}
            iconVariant={COLLAPSIBLE_TRIGGER_ICON_VARIANT.ARROW2}
            isExpanded={isExpanded}
            onToggle={onToggle}
        >
            {children}
        </Collapsible>
    )
}

export default AppSidebarCollapsible;